/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = {
  jumpUrl: '//jump.xunlei.com/jump/', // jump登录接口
  jsonCallbackUrl: 'https://in-xl9-ssl.xunlei.com/index.php/user/jumpkey', // 迅雷9登录接口
  autoJump: false, // 自动请求jump登录接口
  NFERRORCODE_SUCCESS: 0, // 本地接口存在
  NFERRORCODE_FUNCTIONNOTEXIST: 1, // 本地接口不存在
  NFERRORCODE_PARAMETERERROR: 2, // 参数错误
  NFERRORCODE_NOTINXL9: 3 // 非迅雷9环境
};




//////////////////
// WEBPACK FOOTER
// ./conf.js
// module id = 3
// module chunks = 0